import axios from "axios";
import { v4 as uuidv4 } from "uuid";
// import { _smSysAdmin } from "_module/definition/SmSysAdmin";
// import { _mlLibraries } from "../../_module/definition/MlLibraries";
// import { _mlPlaylists } from "../../_module/definition/MlPlaylists";
// import { _mlPlayer } from "../../_module/definition/MlPlayer";
// import { _mlAdmin } from "../../_module/definition/MlAdmin";
import Cookies from "js-cookie";
import {
  validateEmail,
  validateLogin,
  validateResetPassword,
  validateSignup,
  validate2fa,
  validatePhoneNumber,
} from "../../util/validations/UserActionsValidation";
import store from "redux/Store";
import { appConfig } from "App";
module = "/user";
export const actionTypes = {
  LOADING: "LOADING" + module,
  RESENDING: "RESENDING" + module,
  GETCODE: "GETCODE" + module,
  LOAD: "LOAD" + module,
  EXPORTING: "EXPORTING" + module,
  EXPORTED: "EXPORTED" + module,
  EXPORTED_OK: "EXPORTED_OK" + module,
  ERROR: "ERROR" + module,
  SET_USER: "SET_USER",
  SET_2FA: "SET_2FA",
  SET_USER_IMAGE: "SET_USER_IMAGE",
  SET_UNAUTHENTICATED: "SET_UNAUTHENTICATED",
  SET_USER_PERMISSION: "SET_USER_PERMISSION",
  TOGGLE_NAV: "TOGGLE_NAV" + module,
  TOGGLE_PV: "TOGGLE_PV" + module,
  CLEAR_ERRORS: "CLEAR_ERRORS" + module,
  REMOVE_USER_IMAGE: "REMOVE_USER_IMAGE" + module,
  SET_RECENTLY_VIEWED: "SET_RECENTLY_VIEWED" + module,
};

export const toggleNav = (t) => (dispatch) => {
  dispatch({
    type: actionTypes.TOGGLE_NAV,
    payload: t,
  });
};

export const togglePV = (t) => (dispatch) => {
  dispatch({
    type: actionTypes.TOGGLE_PV,
    payload: t,
  });
};

export const loginSSOUser = (token, history) => (dispatch) => {
  axios
    .post("/loginSSO", { token: token })
    .then((res) => {
      cacheLoggedInUser(res.data.user, res.data.token);
      dispatch({
        type: actionTypes.SET_USER,
        payload: res.data.user,
      });
      history.replace("/pl-promo");
    })
    .catch((err) => {
      forgetLoggedInUser();
      history.replace("/signin");
    });
};

export const savePhone = (userData) => (dispatch) => {
  let errors = validatePhoneNumber(userData);

  if (errors) {
    dispatch({
      type: actionTypes.ERROR,
      payload: errors,
    });
    return;
  }

  dispatch({ type: actionTypes.GETCODE });
  axios
    .post("/registerPhone", userData)
    .then((res) => {
      dispatch({
        type: actionTypes.SET_2FA,
        payload: {
          email: res.data.email,
          phone: res.data.phone,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
    });
};

export const twoFaResendCode = (userData) => (dispatch) => {
  dispatch({ type: actionTypes.RESENDING });
  axios
    .post("/2faResend", userData)
    .then((res) => {
      dispatch({
        type: actionTypes.SET_2FA,
        payload: {
          email: res.data.email,
          phone: res.data.phone,
        },
      });
    })
    .catch((err) => {
      forgetLoggedInUser();
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
    });
};

export const twoFaUser = (userData, history) => (dispatch) => {
  let errors = validate2fa(userData);

  if (errors) {
    dispatch({
      type: actionTypes.ERROR,
      payload: errors,
    });
    return;
  }

  dispatch({ type: actionTypes.LOADING });
  axios
    .post("/2fa", userData)
    .then((res) => {
      cacheLoggedInUser(res.data.user, res.data.token);
      dispatch({
        type: actionTypes.SET_USER,
        payload: res.data.user,
      });
      history.replace("/pl-promo");
    })
    .catch((err) => {
      forgetLoggedInUser();
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
    });
};

export const loginUser = (userData, history) => (dispatch) => {
  dispatch({ type: actionTypes.LOADING });
  // let errors = validateLogin(userData);
  // if (errors) {
  //   dispatch({
  //     type: actionTypes.ERROR,
  //     payload: errors,
  //   });
  //   return;
  // }
  // axios
  //   .post("/signInStep1", userData)
  //   .then((res) => {
  //     console.log(res.data)
  //     window.location.replace(res.data);
  //     // if (res.data.tfa) {
  //     //   dispatch({
  //     //     type: actionTypes.SET_2FA,
  //     //     payload: {
  //     //       email: res.data.email,
  //     //       phone: res.data.phone,
  //     //     },
  //     //   });
  //     //   history.replace("/2fa");
  //     // } else {
  //     //   cacheLoggedInUser(res.data.user, res.data.token);
  //     //   dispatch({
  //     //     type: actionTypes.SET_USER,
  //     //     payload: res.data.user,
  //     //   });
  //     //   history.replace("/pl-promo");
  //     // }
  //   })
  //   .catch((err) => {
  //     // forgetLoggedInUser();
  //     dispatch({
  //       type: actionTypes.ERROR,
  //       payload: err.response?.data || { e: err.message },
  //     });
  //   });
};

export const signUpStep1 = (userData, history, done = null) => (dispatch) => {
  // dispatch({ type: actionTypes.LOADING });
  // let errors = validateLogin(userData);
  // if (errors) {
  //   dispatch({
  //     type: actionTypes.ERROR,
  //     payload: errors,
  //   });
  //   return;
  // }
  axios
    .post("/signUpStep1", userData)
    .then((res) => {
      console.log(res.data);
      if(done){
        done(res.data, null);
      }
    })
    .catch((err) => {
      if(done){
        done(null, err);
      }
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
    });
};

export const acceptTerms = (userData, history, done = null) => (dispatch) => {
  // dispatch({ type: actionTypes.LOADING });
  // let errors = validateLogin(userData);
  // if (errors) {
  //   dispatch({
  //     type: actionTypes.ERROR,
  //     payload: errors,
  //   });
  //   return;
  // }
  axios
    .post("/acceptTerms", userData)
    .then((res) => {
      if(done){
        done(res.data, null);
      }
    })
    .catch((err) => {
      if(done){
        done(null, err);
      }
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
    });
};

export const setUserImage = (imageUrl) => (dispatch) => {
  const user = JSON.parse(localStorage.UserLoggedIn);
  user.credentials.orgs[0].imageUrl = imageUrl;
  localStorage.setItem("UserLoggedIn", JSON.stringify(user));
  dispatch({
    type: actionTypes.SET_USER_IMAGE,
    payload: imageUrl,
  });
};

export const removeUserImage = (item) => (dispatch) => {
  const user = JSON.parse(localStorage.UserLoggedIn);
  user.credentials.orgs[0].imageUrl = null;
  localStorage.setItem("UserLoggedIn", JSON.stringify(user));
  dispatch({
    type: actionTypes.REMOVE_USER_IMAGE,
    payload: null,
  });
};

export const setExportLoading = (loading, message = null) => (dispatch) => {
  if (!loading) {
    dispatch({
      type: actionTypes.EXPORTED,
      payload: message ? message : "Exporting Success",
    });
    setTimeout(() => {
      dispatch({
        type: actionTypes.EXPORTED_OK,
      });
    }, 2000);
  } else {
    dispatch({
      type: actionTypes.EXPORTING,
      payload: "Exporting In Progress",
    });
  }
};

export const signupInfo = (handle, done) => (dispatch) => {
  axios
    .post("/signupurl", handle)
    .then((res) => {
      done(res.data, null);
    })
    .catch((err) => {
      done(null, err.response?.data || { e: err.message });
    });
};

export const signupOrgInfo = (handle, done) => (dispatch) => {
  axios
    .post("/signupurlorg", handle)
    .then((res) => {
      done(res.data, null);
    })
    .catch((err) => {
      done(null, err.response?.data || { e: err.message });
    });
};

export const signupUser = (newUserData, bbcSSO, signedup, history) => (
  dispatch
) => {
  let errors = validateSignup(newUserData, bbcSSO, signedup);
  if (errors) {
    dispatch({
      type: actionTypes.ERROR,
      payload: errors,
    });
    return;
  }

  dispatch({ type: actionTypes.LOADING });
  axios
    .post("/signup", newUserData)
    .then((res) => {
      history.replace("/");
      // if (bbcSSO) {
      //   forgetLoggedInUser();
      //   history.replace("/signin?sso=1");
      // } else {
      //   cacheLoggedInUser(res.data.user, res.data.token);
      //   dispatch({
      //     type: actionTypes.SET_USER,
      //     payload: res.data.user,
      //   });
      //   history.replace("/pl-promo");
      // }
    })
    .catch((err) => {
      forgetLoggedInUser();
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
    });
};

export const logoutUser = () => (dispatch) => {
  const { user } = store.getState();
  if (user && user.email) axios.post("/logout", { email: user.email });

  forgetLoggedInUser();
  dispatch({ type: actionTypes.SET_UNAUTHENTICATED });
};

export const loadLocalStorage = (dispatch) => {
  const token = localStorage.FBIdToken;
  if (token) {
    const user = JSON.parse(localStorage.UserLoggedIn);
    dispatch({
      type: actionTypes.SET_USER,
      payload: user,
    });
    axios.defaults.headers.common["Authorization"] = token;
    axios.defaults.headers.common["email"] = user.email;
  } else {
    logoutUser();
    if (window.location.pathname?.toLocaleLowerCase() !== `/signin`) {
      window.location.pathname = `/signin`;
    }
  }
};

export const loadLoggedinUser = (history) => (dispatch) => {
  let skipUrls = ["/sharedstore", "/tourl"];
  if (skipUrls.find((v) => window.location.pathname.startsWith(v))) {
    return;
  }

  let pageUrls = [`/signup`, `/signin`, `/contact`, `/resetpassword`, `/sso`];
  if (pageUrls.find((v) => window.location.pathname.startsWith(v))) {
    logoutUser();
    return;
  }

  loadLocalStorage(dispatch);
};

export const resetPw = (userData, history, done = null) => (dispatch) => {
  let errors = validateEmail(userData.email);
  if (errors) {
    dispatch({
      type: actionTypes.ERROR,
      payload: { email: errors },
    });
    return;
  }

  dispatch({ type: actionTypes.LOADING });
  axios
    .post("/resetpassword", userData)
    .then((res) => {
      dispatch({
        type: actionTypes.LOAD,
        payload: res.data.e,
      });
      // history.replace("/");
      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: err.response?.data || { e: err.message },
      });
      if (done) done(null, err);
    });
};

export const handleResetPw = (userData, done = null) => (dispatch) => {
  // let errors = validateResetPassword(userData);
  // if (errors) {
  //   dispatch({
  //     type: actionTypes.ERROR,
  //     payload: errors,
  //   });
  //   return;
  // }

  // dispatch({ type: actionTypes.LOADING });
  // axios
  //   .post("/handleResetPassword", userData)
  //   .then((res) => {
  //     dispatch({
  //       type: actionTypes.LOAD,
  //       payload: res.data.e,
  //     });
  //     if (done) done(res.data, null);
  //   })
  //   .catch((err) => {
  //     dispatch({
  //       type: actionTypes.ERROR,
  //       payload: err.response?.data || { e: err.message },
  //     });
  //     if (done) done(null, err);
  //   });
};

const getdomain = () => {
  return appConfig.MB_DOMAIN;
};

export const cacheLoggedInUser = (user, tokens) => {
  // localStorage.setItem("UserLoggedIn", JSON.stringify(user));
  localStorage.setItem("auth0IdToken", tokens.bearerIdToken);
  axios.defaults.headers.common["Authorization"] = tokens.bearerIdToken;
  axios.defaults.headers.common["AccessToken"] = tokens.accessToken;
};

export const forgetLoggedInUser = () => {
  // localStorage.removeItem("UserLoggedIn");
  // localStorage.removeItem("auth0IdToken");
  // localStorage.removeItem("UserLoggedIn");
  localStorage.removeItem("auth0IdToken");
  localStorage.removeItem("showNews");
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["AccessToken"];
};

export const clearErrors = (done) => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_ERRORS,
    payload: {},
  });
  if (done) done();
};

export const acceptSignupOrg = (action,  item, done = null) => (dispatch)=>{
  const tId = uuidv4();

  const { lbl, logo } = JSON.parse(appConfig.ORG);

  axios
    .post(`/sharedorg/${action}`, item)
    .then((res) => {
// console.log("accepted",res.data)
      // window.open("http://localhost:3000/pl-promo", "_blank");
      if (done) done(res.data, null);
    })
    .catch((err) => {

      if (done) done(null, err);
    });
}

export const setRecentlyViewed = (key, item, done = null) => (dispatch)=>{
  store.dispatch({
    type: actionTypes.SET_RECENTLY_VIEWED,
    payload: {
      key: key, 
      item: item
    },
  });
}

const redirectToSecondarySSO = ()=>{
  let SECONDARY_SSO = JSON.parse(appConfig.SECONDARY_SSO);
  let data = {
    secondarySSO: {
      CLIENT_ID:SECONDARY_SSO.CLIENT_ID, 
      SCOPE:SECONDARY_SSO.SCOPE, 
      REDIRECT_URI:SECONDARY_SSO.REDIRECT_URI, 
      BASE_URI:SECONDARY_SSO.BASE_URI, 
    }
  }
  const authorizationUrl = `${data.secondarySSO.BASE_URI}?client_id=${data.secondarySSO.CLIENT_ID}&redirect_uri=${data.secondarySSO.REDIRECT_URI}&response_type=code&scope=${data.secondarySSO.SCOPE}`;
  window.location.href = authorizationUrl;
}

export const setUserFromAuth0 = (isAppAuthenticated=false, user=null, tokens=null, history = null, nextPathName = "/pl-promo")=>{
  if(user){
    // ============== secondary SSO
    if(user.secondarySSO && !user.validSecondarySSO){
      return redirectToSecondarySSO();
    }
    // ==============
    cacheLoggedInUser(user, tokens);
    let returnTo = null;
    if(!user.firstName || !user.lastName){
      isAppAuthenticated = false;
      returnTo = `/signupstep1?next=${nextPathName}`;
    }
    else if(!user.termsAccepted){
      isAppAuthenticated = false;
      returnTo = `/terms?next=${nextPathName}`;
    }
    store.dispatch({
      type: actionTypes.SET_USER,
      payload: {
        ...user, 
        appAuthenticated: isAppAuthenticated
      },
    });
    if(!isAppAuthenticated && returnTo && history){
      history.push(returnTo);
    }
  }
  else{
    forgetLoggedInUser();
    store.dispatch({
      type: actionTypes.SET_USER,
      payload: null,
    });
  }
}